import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BreadcrumbsComponent} from './breadcrumbs.component';
import {MatIconModule} from '@angular/material/icon';
import {BreadcrumbComponent} from './breadcrumb/breadcrumb.component';
import {TranslateModule} from "@ngx-translate/core";
import {BreadcrumbsModule} from "@exalif/ngx-breadcrumbs";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    TranslateModule,
    BreadcrumbsModule,
  ],
  declarations: [BreadcrumbsComponent, BreadcrumbComponent],
  exports: [BreadcrumbsComponent],
  providers: [
  ]
})
export class CustomBreadcrumbsModule {
}
